import { c as _c } from "react/compiler-runtime";
import classnames from 'classnames';
import { TextLink } from '@sbt-web/ui';
import { ShieldIcon, ShopIcon } from './Icons';
import classes from './index.module.scss';
type PaymentMethodsProps = {
  isPro: boolean;
};
export const PaymentMethods = t0 => {
  const $ = _c(8);
  const {
    isPro
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2 className={classnames("headline-6", classes.title)}>Modalità di pagamento</h2>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={classes["subtitle-with-icon"]}><div className={classes["icon-wrapper"]}><ShieldIcon /></div><p className="body-text semibold">Pagamento su Subito</p></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className={classes["payment-info"]}>{t2}<p className="body-text small">Paga in totale sicurezza con <b>TuttoSubito</b> e beneficia della Protezione Acquisti. I tuoi dati di pagamento non vengono mai condivisi con il venditore.</p></div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== isPro) {
    t4 = isPro && <div className={classes["payment-info"]}><div className={classes["subtitle-with-icon"]}><ShopIcon /><p className="body-text semibold">Rivenditore verificato</p></div><p className="body-text small">L’identità del Rivenditore viene verificata e validata da Subito. Acquistando da un Rivenditore puoi esercitare il{" "}<b>diritto di recesso</b> entro 14 giorni.</p></div>;
    $[3] = isPro;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <TextLink size="sm" href="https://info.subito.it/tuttosubito.htm?utm_medium=autopromo&utm_source=subito&utm_campaign=free-attraction-lp_tuttosubito_buyer&utm_content=autopromo_pmm_ad-detail_info#compra" target="_blank" rel="noopener">Scopri di più sul nostro servizio TuttoSubito</TextLink>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4) {
    t6 = <div className={classes["payment-methods"]}>{t1}{t3}{t4}{t5}</div>;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
};